import { Expose } from 'class-transformer';

export class Email {
  @Expose()
  public email: string;

  @Expose({ name: 'is_default' })
  public isDefault: boolean;
}
